const Blues = {
    name: "Blues",
    bpm: 88,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default Blues;